export function DateRangeValidator():ng.IDirective {
	return {
		require: 'ngModel',
		link: (scope, elm, attrs, ctrl:ng.INgModelController) => {
			attrs.$observe('validDateRange', (val:string) => {
				let validity:boolean = JSON.parse(val);
				ctrl.$setValidity('dateRange', validity);
			});
		}
	};
};



// WEBPACK FOOTER //
// ./src/phoenix/validators/dateRange.ts